<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-12 titulo-paso">&nbsp;</div>
			</div>
			<div class="row">
				<div class="col-md-12 text-right">
					<b-button id="confirmar" variant="success" v-on:click="confirmar" :disabled="!confirmacion">CONFIRMAR FACTURACION</b-button>&nbsp;
					<hr />
				</div>
			</div>
			<p></p>
			<div class="row">
				<div class="col-12">
					<h5>PROCESO: {{ periodo }}</h5>
				</div>
			</div>
			<div  class="row">
				<div class="col-10" v-for="(archivo, index) of archivos" :key="index">
					<div class="row">
						<div class="col-3">Archivo {{ archivo.archivo }}</div>
						<div class="col-9" style="padding-top: 4px">
							<b-progress max=100 variant="success">
								<b-progress-bar :value="archivo.avance">{{ archivo.avance }}%</b-progress-bar>
							</b-progress>
						</div>
					</div>
				</div>
			</div>
			<div v-if="fin" class="row">
				<div class="col-12 text-center">
					<div class="row">&nbsp;</div>
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-12">
							<h5><i class="fas fa-check-double fa-fw" /> Proceso Finalizado</h5>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"


	export default
	{
		name: "Paso2",
		props: {
			periodo: String, 
			confirmacion: false,
			archivos: [],
		},
		data() {
			return {
				fin: false,
			}
		},
		methods: {

			// Confirma la facturacion
			confirmar() {

				var request = {
					"usuario": this.$usuario,
					"destino": this.$env, 
					"tx": "F0",
					"proceso": "createOF15",
					"periodo": this.periodo,
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					this.fin = true
				})
			},
		}
	}

</script>
<style scoped>

	.barra {
		background-color: green;
		height: 20px;
		color: white;
		text-align: center;
	}

</style>
